import React, { Component, Fragment, cloneElement } from 'react';
import { Table } from 'reactstrap';

export const ExpandedRow = ({children, colSpan, ...otherProps}) => (
  <tr {...otherProps}><td colSpan={colSpan}>{children}</td></tr>
);

export const ExpandableRow = ({children, isOpen, onExpand, renderExpandedRow, ...otherProps}) => (<Fragment>
  <tr {...otherProps}>{children.filter(child => child.type !== ExpandedRow)}</tr>
  {isOpen && renderExpandedRow(children.find(child => child.type === ExpandedRow), {
    colSpan: children.length - 1
  })}
</Fragment>);

// onClick={this.handleExpand(async, onExpand)}

/*
export class ExpandableRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false
    };

    this.handleExpand = this.handleExpand.bind(this);
    this.toggleExpander = this.toggleExpander.bind(this);
  }

  toggleExpander () {
    this.setState(state => ({
      expanded: !state.expanded
    }));
  }

  handleExpand (async, onExpand = () => {}) {
    return () => {
      let { expanded } = this.state;

      if (async) {
        onExpand(expanded).then(this.toggleExpander);
      } else {
        onExpand(expanded);
        this.toggleExpander();
      }
    }
  }

  render () {
    const { expanded } = this.state;
    const { children, async, onExpand, ...otherProps } = this.props;

    return (<Fragment>
      <tr {...otherProps} onClick={this.handleExpand(async, onExpand)}>{children.filter(child => child.type !== ExpandedRow)}</tr>
      {expanded && this.renderExpandedRow(children.find(child => child.type === ExpandedRow), {
        colSpan: children.length - 1
      })}
    </Fragment>);
  }
}
*/

export default class extends Component {
  constructor (props) {
    super(props);

    this.state = {
      expanded: {}
    };
  }

  renderExpandedRow (row, props) {
    return row && (row.props.rendered === undefined || !!row.props.rendered) && cloneElement(row, props);
  }

  updateExpansion (index) {
    this.setState(state => ({
      expanded: {
        ...(this.props.multiExpand?state.expanded:{}),
        [index]: !state.expanded[index]
      }
    }));
  }

  toggleExpansion (index, async, onExpand = () => Promise.resolve(), onClick = () => {}) {
    return e => {
      onClick(e);

      const expanded = !this.state.expanded[index];
      if (async) {
        onExpand(expanded)
        .then(() => this.updateExpansion(index));
      } else if (onExpand(expanded)) {
        this.updateExpansion(index);
      }
    };
  }

  render () {
    const { expanded } = this.state;
    const { children, multiExpand, async, ...otherProps } = this.props;

    return (
      <Table {...otherProps}>
        {React.Children.map(children, child => {
          if (child && child.type === ExpandableRow) return null;

          return child;
        })}
        <tbody>
          {React.Children.map(children, (child, i) => {
            if (!child || child.type !== ExpandableRow) return null;

            return cloneElement(child, {
              ...child.props,
              isOpen: expanded[i] || child.props.isOpen,
              onClick: this.toggleExpansion(i, async, child.props.onExpand, child.props.onClick),
              renderExpandedRow: this.renderExpandedRow
            });
          })}
        </tbody>
      </Table>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ExpandableTable.js